export default "__VITE_ASSET__56b9c467__"